module.exports = __webpack_public_path__ + "static/kohvieri_story_featured_image-8b996efc96f567ced8a6bf9f15e54b4d.png";